// /apps/$appId/settings -> the General section (M11, S9).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/apps/$appId/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/apps/$appId/settings/$section',
      params: { appId: params.appId, section: 'general' },
      search: {},
    });
  },
});
